import PageCommon from "./PageCommon.js";

import DragControl from "./classes/DragControl.js";
import Appear from "./classes/Appear.js";
import BlogPreview from "./classes/BlogPreview.js";

// QUESTA E LA HOME PAGE
export default class PageDefault extends PageCommon {
	constructor() {
		super();
	}
	init($data) {
		super.init($data);
		this.showPreloader(false);

		// dispaccio un evento globale
		this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);

		this.bindEvents();
		this.setPlugins();
		this.colorlink();
		this.setupMenu();

		this.appear = new Appear();
		this.appear.init();

		this.dragControl = new DragControl("div.cover-hp .inner-container", "div.drag-btn img", () => {
			this.appear.resetElements();
		});
		this.dragControl.init();
		try {
			document.querySelector(".top-newsletter a").addEventListener("click", (event) => {
				event.preventDefault();
				const target = document.querySelector("#newsletter");
				TweenMax.to("html, body", 1, { scrollTo: { y: target.getBoundingClientRect().top - 100, autoKill: false }, ease: Cubic.easeInOut });
			});
		} catch (ex) {

        }

		this.blogPreview = new BlogPreview();
		this.blogPreview.init();
	}

	get isHomepage() {
		return true;
	}
}
